import React from "react";
import * as AccordionRadix from "@radix-ui/react-accordion";
import type { AccordionItemProps } from "@radix-ui/react-accordion";

type ItemProps = AccordionItemProps &
  React.RefAttributes<HTMLDivElement> & {
    children: string | React.ReactNode;
  };

const Item = React.forwardRef<HTMLDivElement, ItemProps>(
  ({ children, ...props }, forwardedRef) => {
    return (
      <AccordionRadix.Item {...props} ref={forwardedRef}>
        {children}
      </AccordionRadix.Item>
    );
  }
);

export default Item;
